import * as actionTypes from "../actionTypes";

export const createProductCategory = (payload) => ({
  type: actionTypes.CREATE_PRODUCT_CATEGORY,
  payload,
});
export const getProductCategory = () => ({
  type: actionTypes.GET_PRODUCT_CATEGORY_LIST,
});
export const setProductCategory = () => ({
  type: actionTypes.SET_PRODUCT_CATEGORY_LIST,
});
export const updateProductCategory = (payload) => ({
  type: actionTypes.UPDATE_PRODUCT_CATEGORY,
  payload,
});
export const deleteProductCategory = (payload) => ({
  type: actionTypes.DELETE_PRODUCT_CATEGORY,
  payload,
});
export const updateProductCategoryStatus = (payload) => ({
  type: actionTypes.UPDATE_PRODUCT_CATEGORY_STATUS,
  payload,
});
